<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="dedication">
<header>
<h1 class="topictitle1" id="de1"><a href="#/nav#nde1"><span class="title">Dedication</span><br/></a></h1>
</header>
<div class="dedication_group">
<p class="dedication">This book is dedicated to my children,</p>
<p class="dedication">Kahbran, Eden, and Mimi,</p>
<p class="dedication">as well as all those who are moved to fan the fire.</p>
<p class="dedication"><span class="foreign_language"><i>✭</i></span></p>
</div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Dedication.vue?6d8ff55d